import type { Home } from '@lmc/ts-common'
import { useSelector } from 'react-redux'

// The Backoffice Family flag writes both `home.family` and
// `home.features.family`, but `features` is only backfilled on a Backoffice
// save, so the top-level boolean is the one every home is guaranteed to have.
// It is also what the settings-tab gate reads (see accountsSettings
// navigationTabs), so both gates agree for every home.
const useFamilyAccess = (): boolean => {
  const family: boolean | undefined = useSelector(
    (state: { global: { home: Home } }) => state.global.home.family
  )

  return Boolean(family)
}

export default useFamilyAccess
